var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackFriday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6,46.5L47.6,46.5c-2.3-1.4-5.2-0.7-6.6,1.6c-0.7,1.1-0.9,2.4-0.6,3.7c0.3,1.3,1.1,2.3,2.2,3l0,0 c1.1,0.7,2.4,0.9,3.6,0.6c1.3-0.3,2.3-1,3-2.2C50.5,50.9,49.8,47.9,47.6,46.5z M47.1,52.1c-0.3,0.6-0.9,0.9-1.5,1.1 c-0.6,0.2-1.4,0.1-1.9-0.3s-1-0.9-1.1-1.6s-0.1-1.4,0.4-1.9c0.7-1.1,2.3-1.5,3.4-0.8l0,0C47.5,49.3,47.9,50.9,47.1,52.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39,40.6c1.1,0.7,2.4,0.9,3.6,0.6c1.3-0.3,2.3-1,3-2.2c1.4-2.3,0.7-5.2-1.6-6.6l0,0 c-2.3-1.4-5.2-0.7-6.6,1.6c-0.7,1.1-0.9,2.4-0.6,3.7C37.1,38.8,37.9,39.9,39,40.6L39,40.6z M43.6,37.9c-0.3,0.6-0.9,0.9-1.5,1.1 s-1.4,0.1-1.9-0.3c-0.6-0.3-1-0.9-1.1-1.6c-0.2-0.6-0.1-1.4,0.4-1.9c0.7-1.1,2.4-1.5,3.5-0.7c0.6,0.3,1,0.9,1.1,1.6 C44.1,36.7,44,37.4,43.6,37.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.1,41c-0.2-0.6-0.7-1-1.4-0.9c-0.4,0.1-0.6,0.2-1,0.2l-3.2,0.8c-4.9,1.2-10,2.4-14.9,3.6 c-0.3,0.1-0.3,0.1-0.5,0.3c0,0.1-0.2,0.1-0.2,0.1l-0.3,0.1v0.2c0,0.1,0,0.1,0,0.2c0,0.2,0,0.3,0,0.5c0.1,0.3,0.3,0.5,0.5,0.6 s0.7,0.2,1,0.1c6.3-1.5,12.7-3.1,19-4.6C53.8,42.2,54.2,41.6,54.1,41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,69.3c-0.7,0-1.5-0.2-2.1-0.6L21.8,57.9c-1-0.6-1.7-1.5-2-2.6S19.7,53,20.2,52l18.1-31.2 c0.6-1,1.6-1.8,2.8-2l14.2-3.1c2.1-0.5,4.3,0.8,5,2.8l4.7,14c0.4,1.2,0.3,2.5-0.4,3.6L46.5,67.2C45.7,68.6,44.2,69.3,42.8,69.3z  M56.3,17.9c-0.1,0-0.3,0-0.4,0l0,0L41.7,21c-0.5,0.1-1,0.5-1.3,0.9L22.2,53.2c-0.3,0.5-0.3,1-0.2,1.5c0.1,0.5,0.5,0.9,0.9,1.2 l18.8,10.9c0.9,0.5,2.2,0.2,2.7-0.7L62.8,35c0.3-0.5,0.4-1.1,0.2-1.7l-4.7-14C57.9,18.5,57.1,17.9,56.3,17.9z M55.6,16.9 L55.6,16.9L55.6,16.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 53.7,
    cy: 24.5,
    r: 1.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFriday);
export default __webpack_public_path__ + "static/media/BlackFriday.a793634692a7b93be6be4ba7c5164340.svg";
export { ForwardRef as ReactComponent };